<script>
    import Carousel from "svelte-carousel";
    import Product from "./Product.svelte";

    import {onDestroy, onMount} from "svelte";
    import {API_URL} from "../../../env";
    import ProductsLoading from "../../placeholders/ProductsLoading.svelte";

    let particlesToShow = 4;
    let particlesToScroll = 4;

    let resizeObserver;

    let data = undefined;
    let carouselReady = false;

    async function fetchData () {
        const res = await fetch(API_URL+'/cheapProducts');
        const body = await res.json();
        return body.data
    }

    function setParticlesBasedOnWidth(width) {
        if (width < 767.98) {
            particlesToShow = 1;
            particlesToScroll = 1;
        } else if (width < 991.98) {
            particlesToShow = 2;
            particlesToScroll = 2;
        } else if (width < 1199.98) {
            particlesToShow = 3;
            particlesToScroll = 3;
        } else {
            particlesToShow = 4;
            particlesToScroll = 4;
        }

        carouselReady = true;
    }

    onMount(async () => {
        data = await fetchData();

        setParticlesBasedOnWidth(window.innerWidth);

        resizeObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
                setParticlesBasedOnWidth(entry.contentRect.width);
            }
        });

        resizeObserver.observe(document.body);
    });

    onDestroy(() => {
        if (resizeObserver) {
            resizeObserver.disconnect();
        }
    });
</script>

{#if data && data.length > 0}
    <section class="container mb-2" id="sale">
        <div class="sale">
            <div class="row my-4">
                <div class="col-12">
                    <h2 class="section-title">Zľavnené pneumatiky</h2>
                    <div class="sale-carousel">
                        {#if data && carouselReady}
                            {#if data.length <= 4}
                                <div class="row">
                                    {#each data as product}
                                        <div class="col-md-6 col-lg-4 col-xl-3">
                                            <Product data={product} />
                                        </div>
                                    {/each}
                                </div>
                            {:else}
                                <Carousel
                                        particlesToShow={particlesToShow}
                                        particlesToScroll={particlesToScroll}
                                        gapSize={20}
                                        let:showPrevPage
                                        let:showNextPage
                                >

                                    {#each data as product}
                                        <div class="item">
                                            <Product data={product} />
                                        </div>
                                    {/each}

                                    <div slot="prev" on:click={showPrevPage} class="custom-arrow custom-arrow-prev">
                                        <i class="fal fa-fw fa-arrow-left-long"></i>
                                    </div>
                                    <div slot="next" on:click={showNextPage} class="custom-arrow custom-arrow-next">
                                        <i class="fal fa-fw fa-arrow-right-long"></i>
                                    </div>
                                </Carousel>
                            {/if}
                        {:else}
                            <div class="row">
                                <ProductsLoading items={particlesToShow} />
                            </div>
                        {/if}
                    </div>
                </div>
            </div>
        </div>
    </section>
{/if}

<style>
    :global(.sale-carousel .sc-carousel__pages-window) {
        padding-top: 1rem;
    }
    :global(.sale-carousel .sc-carousel-dots__container) {
        gap: .5rem !important;
    }
    :global(.sale-carousel .sc-carousel-dots__dot-container) {
        width: fit-content !important;
    }
    :global(.sale-carousel .sc-carousel-dot__dot) {
        background-color: var(--color-slate-300) !important;
        width: .6rem !important;
        height: .6rem !important;
        border-radius: 50% !important;
        outline: none !important;
    }
    :global(.sale-carousel .sc-carousel-dot__dot_active) {
        background-color: #E65025 !important;
        width: 2rem !important;
        border-radius: .5rem !important;
        opacity: 1 !important;
    }
    :global(.sale-carousel .custom-arrow) {
        position: absolute;
        border: 1px solid var(--color-slate-200);
        background-color: var(--color-slate-100);
        color: var(--color-slate-400);
        border-radius: 50%;
        height: 3rem;
        width: 3rem;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: .1s linear;
        cursor: pointer;
        z-index: 150;
    }
    :global(.sale-carousel .custom-arrow:hover) {
        border-color: var(--color-slate-300);
        background-color: var(--color-slate-200);
    }
    :global(.sale-carousel .custom-arrow.custom-arrow-prev) {
        left: -1.4rem;
        top: 10.5rem;
    }
    :global(.sale-carousel .custom-arrow.custom-arrow-next) {
        right: -1.4rem;
        top: 10.5rem;
    }

    .product.skeleton {
        height: 23rem;
        user-select: none;
        pointer-events: none;
    }
    .product.skeleton .product-logo {
        height: 3rem;
        width: 10rem;
        margin: 1rem auto 0 auto;
        border-radius: 2.5rem;
        animation: skeletonLoading 1s linear infinite alternate;
    }
    .product.skeleton .product-name {
        height: 2rem;
        width: 80%;
        margin: 1rem auto;
        border-radius: 2.5rem;
        animation: skeletonLoading 1s linear infinite alternate;
    }
    .product.skeleton .product-body .product-image {
        width: 9rem;
        margin: auto;
        border-radius: 50%;
        animation: skeletonLoading 1s linear infinite alternate;
    }
    .product.skeleton .product-body .product-props .prop-item {
        border-color: transparent;
        border-radius: 2.5rem;
        animation: skeletonLoading 1s linear infinite alternate;
    }
    .product.skeleton .product-footer {
        height: 6rem;
        animation: skeletonLoading 1s linear infinite alternate;
    }
</style>